module.exports = __webpack_public_path__ + "static/media/glance.dafeb6f7.svg";